import React from 'react';
import styled from 'styled-components';
import { Title } from '@kvdbil/components';
import { ArticleRecord } from '~/config/generated/graphql';
import { useTranslation } from '~/Locale';
import Link from '~/App/shared/components/Link';
import { DeepPartial } from '@test/mocks';
import ArticleList from './ArticleList';

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 1rem;
  padding-bottom: 2rem;
`;

const StyledLink = styled(Link)`
  text-transform: uppercase;
`;

type ArticleCardListBlockProps = {
  heading: string;
  categorySlug: string;
  articles?: DeepPartial<ArticleRecord>[];
  articlesLimit?: number;
  isLoading?: boolean;
};

export const ArticleCardListBlock = ({
  heading,
  categorySlug,
  articles,
  articlesLimit,
  isLoading = false
}: ArticleCardListBlockProps) => {
  const { t } = useTranslation();

  const limitedArticles =
    articles && articlesLimit ? articles.slice(0, articlesLimit) : articles;

  const isShowAllLinkAvailable =
    articles && articlesLimit && articles.length > articlesLimit;

  return (
    <div>
      <HeadingWrapper>
        <Title as="span">{heading}</Title>
        {isShowAllLinkAvailable && (
          <StyledLink to={`/ROUTES.BLOG/${categorySlug}`}>
            {t('Show all')}
          </StyledLink>
        )}
      </HeadingWrapper>
      <ArticleList
        isLoading={isLoading}
        articles={limitedArticles}
        limit={articlesLimit}
      />
    </div>
  );
};

export default ArticleCardListBlock;
